import { zServiceVehicleCommonSchema } from "./serviceVehicle.common";
import { zDayjsSchema } from "@/types/zDayjs";
// Доменная схема для ServiceVehicle (может быть расширена связанными данными)
export const zServiceVehicleSchemaDom = zServiceVehicleCommonSchema
    .omit({
    lastServiceDate: true,
})
    .extend({
    lastServiceDate: zDayjsSchema.optional(),
});
export const zServiceVehicleSchemaCreateDom = zServiceVehicleSchemaDom.omit({
    id: true,
});
